var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Revealer',[_c('vue-json-pretty',{staticClass:"text-left",attrs:{"data":JSON.parse(_vm.rowData.row.message),"deep":1,"showLength":"","showLine":"","showDoubleQuotes":"","highlightMouseoverNode":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }